import DeliverableCard from './components/DeliverableCard';
import type { Database } from '@/types/database.types';
type Project = Database['public']['Tables']['projects']['Row'];
import type { DeliverableWithIngest } from '.';

export default function VideosTab({
  deliverables,
}: {
  deliverables: DeliverableWithIngest[];
  project: Project;
}) {
  const allDeliverables = deliverables.map((deliverable) => (
    <DeliverableCard deliverable={deliverable} key={deliverable.id} />
  ));

  return <div>{allDeliverables}</div>;
}
